import { PAYMENT_RETURN_ROUTES } from './payment'
import { BUILD_BASE_PATH } from './runtimeBasePath'

export const ROUTES = {
  HOME: '/',
  // Partners
  PARTNERS: {
    ACCOUNT: {
      LOGIN: '/partners/account/login',
      SIGNUP: (userType: string) => `/partners/account/signup/${userType}`,
      SIGNUP_COMPLETE: '/partners/account/signup/complete',
      FIND_ID: '/partners/account/find-id',
      FIND_ID_FAIL: '/partners/account/find-id/fail',
      RESET_PASSWORD: '/partners/account/reset-password',
      RESET_PASSWORD_COMPLETE: '/partners/account/reset-password/complete',
      CHANGE_PASSWORD_COMPLETE: '/partners/account/change-password/complete',
      CONTACT_LIST: '/partners/account/contact-list',
      CHANGE_CONTACT: (contactType: string) =>
        `/partners/account/change-contact/${contactType}`,
      CHANGE_EMAIL: '/partners/account/change-email',
    },
    APPLY: {
      INTRO: '/partners/apply/intro',
      BUSINESS_TYPE: '/partners/apply/business-type',
      DOCUMENTS: '/partners/apply/documents',
      PHOTOS: '/partners/apply/photos',
      COMPLETE: '/partners/apply/complete',
      RESUBMIT: '/partners/apply/resubmit',
      RESUBMIT_COMPLETE: '/partners/apply/resubmit-complete',
      VERIFY_ID_IMAGE: (documentType: string, returnUrl?: string) =>
        `/partners/apply/verify-id-image?type=${documentType}${returnUrl ? `&returnUrl=${encodeURIComponent(returnUrl)}` : ''}`,
    },
    ONSITE: {
      INTRO: (placeHashId: string) =>
        `/partners/on-site/payment/${placeHashId}`,
    },
  },
  // WEB
  RESERVATION: {
    LOGIN: '/reservation/login',
    LOGIN_CALLBACK: '/reservation/login/callback',
    INTRO: (promotionName: string | null) =>
      `/reservation/intro${promotionName ? `/${promotionName}` : ''}`,
    REGISTER: {
      MODEL: '/reservation/register/model',
    },
    PRODUCT: {
      LIST: ({
        detailModelId,
        fuelId,
        type,
      }: {
        detailModelId: string
        fuelId: string
        type?: string
      }) =>
        `/reservation/product/list?detailModelId=${detailModelId}&fuelId=${fuelId}${type ? `&type=${type}` : ''}`,
      DETAIL: (productId: string) => `/reservation/product/${productId}`,
    },
    PLACE: {
      LIST: '/reservation/place/list',
    },
    PAYMENT: {
      PREPARE: '/reservation/payment/prepare',
      // PC 결제 폼의 `action`·`location.href` 에 그대로 들어가 접두어까지 붙여 둔다
      CALLBACK: (pg: string) =>
        `${BUILD_BASE_PATH}${PAYMENT_RETURN_ROUTES.RESERVATION_CALLBACK(pg)}`,
      DETAIL: (reservationId: number) =>
        `/reservation/payment/${reservationId.toString()}`,
      INSTALLMENT_GUIDE: '/reservation/payment/installment-guide',
      FAIL: PAYMENT_RETURN_ROUTES.RESERVATION_FAIL,
      SUCCESS: '/reservation/payment/success',
    },
  },
  // 정비소 추가 결제 웹뷰 — 대상 식별은 알림톡 링크 해시(#) 토큰이 담당하므로 경로 파라미터가 없다
  ADDITIONAL_PAYMENT: {
    DETAIL: '/additional-payment',
    COMPLETE: '/additional-payment/complete',
    FAIL: '/additional-payment/fail',
  },
  // Mycle Web-View
  /** 자동차세 안내 */
  CAR_TAX: '/car-tax',
  MAINTENANCE: {
    /** 정비 항목 상세 — typeId·macarId 둘 다 없으면 404 */
    DETAIL: ({
      typeId,
      macarId,
      from,
    }: {
      typeId: number
      macarId: string
      from?: string
    }) =>
      `/maintenance/${typeId}?macarId=${macarId}${from ? `&from=${from}` : ''}`,
  },
  SCHEDULE: {
    /** 스케줄 목록. 카테고리 필터는 `?category=` 쿼리로 딥링크할 수 있다 */
    LIST: '/schedule',
    EDIT: (scheduleId: number) => `/schedule-edit?serverId=${scheduleId}`,
  },
  GAS_VOUCHERS: '/gas-vouchers',
  GAS_VOUCHER_DETAIL: (gasVoucherId: string) =>
    `/gas-vouchers/detail?gasVoucherId=${gasVoucherId}`,
  CAR_STORY: {
    HOME: '/car-story',
    TAB: (tab: 'home' | 'maintenance' | 'drive' | 'now') =>
      `/car-story?tab=${tab}`,
    CONTENT_DETAIL: (serverId: number) => `/car-story/contents/${serverId}`,
  },
}

export const PARTNERS_BRIDGE_PATH = {
  FROM: {
    ACCOUNT: {
      ROOT: '/account',
      SIGNUP_COMPLETE: '/signup/complete',
      CONTACT_LIST: '/account/contact-list',
      CHANGE_EMAIL: '/account/change-email',
      CHANGE_PASSWORD: '/account/change-password',
      FIND_ID: '/account/find-id',
      RESET_PASSWORD: '/account/reset-password',
    },
    APPLY: {
      INTRO: '/apply/intro',
      BUSINESS_TYPE: '/apply/business-type',
      DOCUMENTS: '/apply/documents',
      PHOTOS: '/apply/photos',
      RESUBMIT: '/apply/resubmit',
    },
  },
  TO: {
    ACCOUNT: {
      ROOT: '/account',
      SIGNIN: '/signin',
      SIGNUP: '/signup',
    },
  },
} as const

export const EXTERNAL_LINKS = {
  POLICY: 'https://mycle.co.kr/agree/agree_1_mycle.html?check=webpage',
  PRIVACY_POLICY: 'https://mycle.co.kr/agree/agree_2_mycle.html?check=webpage',
}

export const buildRedirectUrl = (path: string): string => {
  const baseUrl = process.env.NEXT_PUBLIC_WEB_SERVICE_URL
  const fullPath = path.startsWith('/v2') ? path : `/v2${path}`

  return `${baseUrl}${fullPath}`
}
